import React from "react";

import "./ArticleCard.scss";

export type ArticleCardProps = {
  cx?: string;
  banner: any;
  contents: {
    title: string;
    subtitle: string;
    date: string;
    desc?: string;
  };
  onClick?: any;
};

export const ArticleCard: React.FC<ArticleCardProps> = ({
  cx = "",
  contents,
  banner,
  onClick,
}) => {
  return (
    <div className={`ArticleCard ${cx}`} onClick={onClick}>
      <div className={"banner"}>{banner}</div>
      <div className="text-wrapper">
        <span className="subtitle">{contents.subtitle}</span>
        <span className="date">{contents.date}</span>
        <p className="title">{contents.title}</p>
        <p className="desc">{contents.desc}</p>
      </div>
    </div>
  );
};
